(ns livefeed.footer.footer
  (:require
   [clojure.string :as str]
   [livefeed.api :refer [chat-public-url]]
   [livefeed.feed :as feed]
   [livefeed.footer.blocked :as blocked]
   [livefeed.footer.login :as login]
   [livefeed.footer.message-input :as message-input]
   [livefeed.footer.message-status :as message-status]
   [livefeed.footer.reaction-buttons :as reaction-buttons]
   [livefeed.footer.scrollable-footer :as scrollable]
   [livefeed.i18n :refer [translate]]
   [livefeed.message-status :as status :refer [ready-to-send?]]
   [livefeed.properties :as properties]
   [livefeed.state :as state]
   [livefeed.system-color-scheme :refer [system-color-scheme]]
   [livefeed.tunnus :as tunnus]))

(defn component [open-blocked-modal input-ref best?]
  (let [feed-reactions @state/feed-reactions
        reaction-count (count feed-reactions)
        status @status/status

        input-component-v2  [:<>
                             [:message-input-embed {"language" (properties/get-property :language)
                                                    "base-url" (chat-public-url)
                                                    "theme" (or (properties/get-property :colorScheme) @system-color-scheme)
                                                    "topic-id" @state/topic-id}]
                             (if @state/use-chat-public-reactions
                               [:reaction-buttons-embed {"language" (properties/get-property :language)
                                                         "base-url" (chat-public-url)
                                                         "topic-id" @state/topic-id}]
                               [reaction-buttons/component feed-reactions])]
        input-component (if (ready-to-send?)
                          [:<>
                           [message-input/component
                            (str (translate (if @feed/quoted-message
                                              :reply-to-message
                                              :write-a-message)) "...")
                            input-ref
                            state/input-value]
                           (when (and (pos? reaction-count) (str/blank? @state/input-value) (not @state/input-focused?))
                             (if @state/use-chat-public-reactions
                               [:reaction-buttons-embed {"language" (properties/get-property :language)
                                                         "base-url" (chat-public-url)
                                                         "topic-id" @state/topic-id}]
                               [reaction-buttons/component feed-reactions]))]
                          [message-status/component status best?])]
    (if @state/use-chat-public-input
      (cond
        (false? @state/logged-in)
        [login/component tunnus/login!]

        (< 2 reaction-count)
        [:div.input-component-v2
         [scrollable/component
          input-component-v2]]

        :else
        [:div.input-component-v2.yle-livefeed__fixed-footer {:class (str "yle-livefeed__fixed-footer--" reaction-count)}
         input-component-v2])
      (cond
        (= :blocked status)
        [blocked/component open-blocked-modal]

        (= :topic-locked status)
        [scrollable/component input-component]

        (false? @state/logged-in)
        [login/component tunnus/login!]

        (< 2 reaction-count)
        [scrollable/component
         input-component]

        :else
        [:div.yle-livefeed__fixed-footer {:class (str "yle-livefeed__fixed-footer--" reaction-count)}
         input-component]))))


